import { type PropsWithChildren, useState } from 'react'
import { ScheduleItemsContext } from './ScheduleItemsContext'
import type { RowItem } from './useFilteredItems'
import { useInitializeItems } from './useInitializeItems'

type ScheduleItemsContextProviderProps<T extends RowItem> = {
  rows?: T[]
  isLoading: boolean
}
export function ScheduleItemsContextProvider<T extends RowItem>({
  children,
  rows: unfilteredRows,
  isLoading,
}: PropsWithChildren<ScheduleItemsContextProviderProps<T>>) {
  const {
    items: data,
    rows,
    search,
    isLoading: initializing,
    getOverlappingSchedules,
  } = useInitializeItems<T>(unfilteredRows)

  const [editingTemplateDriverId, editTemplateForDriver] = useState<string | null>(null)

  return (
    <ScheduleItemsContext.Provider
      value={{
        data,
        rows,
        search,
        isLoading: isLoading || initializing,
        getOverlappingSchedules,
        editingTemplateDriverId,
        editTemplateForDriver,
      }}
    >
      {children}
    </ScheduleItemsContext.Provider>
  )
}
